{
    "aboutbanner.label": "{siloName} Spazi sono diversi",
    "account.admin_language": "Lingua preferita",
    "account.admin_language_no_language": "Nessuna lingua",
    "account.admin_moderation_dash_settings": "Impostazioni della dashboard di moderazione",
    "account.title": "Account",
    "account_delete.confirm_description": "La cancellazione del suo profilo è irreversibile. L'eliminazione di tutti i dati e attività associate può richiedere fino a 72 ore.",
    "account_delete.confirm_heading": "È sicuro di voler eliminare i dati del suo profilo?",
    "account_delete.description": "Se richiesto, la cronologia delle discussioni del suo account e le sue partecipazioni saranno eliminate. Questa azione è irreversibile.",
    "account_delete.heading": "Cancellare i miei dati",
    "account_request_data.heading": "Richiedere i miei dati",
    "account_request_data.instructions": "Manda un'e-mail a [privacy@newpublic.org](mailto:privacy@newpublic.org) per richiedere una copia dei tuoi dati associati a questo spazio di discussione. Potrebbe volerci fino a 30 giorni per elaborare la richiesta.",
    "account_revoke_permissions.confirm_heading": "Revocare i permessi di amministratore di {identifier}?",
    "account_revoke_permissions.confirm_text": "{identifier} non avrà più i permessi di amministratore.",
    "account_revoke_permissions.revoke_button": "Revoca permessi",
    "action.block": "Bloccare",
    "action.cancel": "Annullare",
    "action.create_new_voting": "Creare un nuovo voto",
    "action.delete": "Elimina",
    "action.edit": "Modificare",
    "action.pinned": "In evidenza",
    "action.post": "Pubblicare",
    "action.reply_to_user": "Rispondere a {userName}...",
    "action.report": "Segnalare",
    "action.save": "Salvare",
    "action.unblock": "Sbloccare",
    "admin.category_analysis_heading": "Analisi",
    "admin.category_developer_tools_heading": "Strumenti per sviluppatori",
    "admin.category_editorial_heading": "Editoriale",
    "admin.category_moderation_heading": "Moderazione",
    "admin.category_owner_tools_heading": "Strumenti per proprietari",
    "admin.category_starred_heading": "In evidenza",
    "admin.window_title": "Dashboard admin",
    "admin_mod_link.admin_users_description": "Gestire le autorizzazioni degli utenti amministratori.",
    "admin_mod_link.editorial_dashboard_description": "Gestire spazi e altro ancora.",
    "admin_mod_link.editorial_dashboard_label": "Pannello editoriale",
    "admin_mod_link.moderation_dashboard_description": "Moderare le discussioni nel dashboard ristrutturato. (WIP)",
    "admin_mod_link.ranking_eval_description": "Valutare diversi algoritmi di classificazione su conversazioni reali.",
    "admin_mod_link.ranking_eval_label": "Valutazione della Classificazione",
    "admin_mod_link.settings_description": "Gestire formati e funzionalità organizzativi.",
    "admin_mod_link.settings_label": "Impostazioni",
    "admin_mod_link.storybook_description": "Visualizzare i componenti PSI in Storybook.",
    "admin_mod_link.storybook_label": "Storybook",
    "admin_users.add_admins_button": "Aggiungere amministratori",
    "admin_users.add_new_admins_label": "Aggiungere nuovi amministratori",
    "admin_users.adding_admins_message": "Aggiunta amministratori...",
    "admin_users.emails_placeholder": "Email degli utenti da aggiungere",
    "admin_users.heading": "Utenti admin",
    "admin_users.loading_message": "Caricamento degli amministratori...",
    "admin_users.updating_roles_message": "Aggiornamento dei ruoli in corso...",
    "admins.actions.edit": "Modificare",
    "admins.actions.revoke": "Revocare permessi",
    "admins.actions.revoke-failed": "Impossibile revocare i permessi di amministratore di {userIdentity}",
    "admins.actions.revoked": "{userIdentity} non ha più i permessi di amministratore",
    "admins.all_admins": "Tutti",
    "admins.column_actions": "Azioni",
    "admins.column_name": "Nome",
    "admins.column_posts": "Post",
    "admins.column_roles": "Permessi interni",
    "admins.column_title": "Titolo",
    "admins.error": "Impossibile recuperare la tabella degli amministratori",
    "admins.tab_label": "Profili del personale",
    "admins.table.search": "Cercare...",
    "admins.title": "Profili del personale",
    "agree": "D’accordo",
    "aitag.ai_moderated": "Moderato dall’IA",
    "appError.goHome": "Tornare indietro",
    "appError.page_forbidden": "Il suo account non può accedere a questa pagina.",
    "appError.page_not_found": "La pagina che sta cercando non esiste.",
    "appError.page_unauthorized": "Non ha il permesso di accedere a questa pagina.",
    "article.admin_only_error": "Deve effettuare l’accesso come amministratore per visualizzare questa schermata.",
    "article.login_button": "Accedere",
    "article.no_teaser_error": "Nessun teaser definito",
    "article.zdf_section": "ZDF",
    "article_teaser_position.max_positions": "Massimo di 2 posizioni consentite",
    "audience_input.community_guidelines_title": "Linee guida della comunità",
    "audience_input.composer_placeholder": "Condividi i tuoi pensieri...",
    "audience_input.your_reply_label": "La sua risposta",
    "audience_input_template.description": "Raccogliere domande, testimonianze e storie dagli utenti. Questo consente un maggiore coinvolgimento.",
    "audience_input_template.label": "Input del pubblico",
    "blocklist.empty_list": "La lista nera è vuota.",
    "blocklist.include_alternative_spellings": "Includi varianti ortografiche",
    "blocklist.only_singular_term": "Solo termine singolare",
    "blocklist.single_term_not_deleted": "Impossibile eliminare il termine della blocklist",
    "blocklist.singular_term_tag": "Termine singolare",
    "blocklist.term_adoption_description": "Scegli se usare i termini esattamente come inseriti oppure in forma estesa.",
    "blocklist.terms_not_added_duplicate": "Il termine della blocklist esiste già: {duplicateTerms}",
    "blocklist.terms_not_added_mixed": "Il termine della blocklist esiste già: {duplicateTerms}. Impossibile aggiungere il termine della blocklist, riprova: {refusedTerms}",
    "blocklist.terms_not_added_refused": "Impossibile aggiungere il termine della blocklist, riprova: {refusedTerms}",
    "blocklist.terms_not_deleted": "Impossibile eliminare {failedCount} termini della blocklist su {totalCount}",
    "button.react": "Reagire",
    "button.react_button_aria": "{count} {tLabel} ({tSelected})",
    "button.react_button_deselected": "deselezionato",
    "button.react_button_selected": "Selezionato",
    "button.reacted": "Reagito",
    "byline.deleted_user": "Utente eliminato",
    "byline.edited": "Modificato",
    "channel_settings.title": "Impostazioni del canale",
    "channels.no_channels_available": "Nessun canale disponibile",
    "channels.select_channel": "Selezionare un canale",
    "channels.title": "Canale",
    "close_conversation.closed_message": "Questa conversazione è ora chiusa.",
    "comment.cancel_button": "Annullare",
    "comment.confirm_leave_description": "Le modifiche apportate non verranno salvate.",
    "comment.confirm_leave_heading": "È sicuro di voler uscire?",
    "comment.delete_button": "Elimina",
    "comment.delete_modal_heading": "È sicuro di voler eliminare questo post?",
    "comment.delete_modal_warning": "Questa azione non può essere annullata.",
    "comment.edit_button": "Modificare",
    "comment.post_button": "Pubblicare",
    "comment.posting": "Pubblicazione in corso...",
    "comment.public_comment_subtitle": "Commento pubblico",
    "comment.read_more_button": "Leggere di più",
    "comment.reply_button": "Rispondere",
    "comment.report_button": "Segnalare",
    "comment.show_less": "Mostrare meno",
    "comment.show_more_replies_plural": "Mostrare {count} altre risposte",
    "comment.show_more_reply_singular": "Mostrare {count} altra risposta",
    "comment.show_original": "Mostrare l'originale ({language})",
    "comment.show_translation": "Mostrare la traduzione ({language})",
    "comment.update_button": "Aggiornare",
    "comment.updating": "Aggiornamento in corso...",
    "comment.your_reply_label": "La sua risposta",
    "comment_feedback.only_visible_to_you": "Visibile solo per lei",
    "comment_slider.change_vote_button": "Aggiorni la sua risposta",
    "comment_slider.community_guidelines_title": "Linee guida della comunità",
    "comment_slider.its_complicated": "È complicato",
    "comment_slider.no_with_reservations": "Piuttosto no",
    "comment_slider.public_response": "Risposta pubblica",
    "comment_slider.recording_vote": "Registrazione del voto...",
    "comment_slider.response": "risposta",
    "comment_slider.responses": "risposte",
    "comment_slider.share_thoughts": "Condividi i tuoi pensieri",
    "comment_slider.skip_change_vote": "Saltare e cambiare voto",
    "comment_slider.skip_submit_vote": "Saltare e inviare voto",
    "comment_slider.slide_to_respond": "Scorrere per rispondere:",
    "comment_slider.strongly_no": "Decisamente no",
    "comment_slider.strongly_yes": "Decisamente sì",
    "comment_slider.update_response": "Aggiorna la tua risposta",
    "comment_slider.yes_with_reservations": "Piuttosto sì",
    "comment_slider.your_reply_label": "La sua risposta",
    "comment_slider_editable_positions.heading": "Personalizzare il cursore dei commenti",
    "comment_slider_template.description": "Chiedere agli utenti di rispondere alla sua domanda su uno spettro (ad es. “Decisamente no” a “Decisamente sì”).",
    "comment_slider_template.label": "Cursore commento",
    "common.access_denied": "Accesso negato",
    "common.are": "sono",
    "common.cancel": "Annullare",
    "common.download": "Scaricare",
    "common.is": "è",
    "common.loading": "Caricamento...",
    "common.select": "Selezionare",
    "community_guidelines.aria_popup_label": "{label} (finestra pop-up)",
    "community_guidelines.category_engage_respectfully": "Partecipi con rispetto",
    "community_guidelines.category_no_disruptive_behavior": "Nessun comportamento disturbante",
    "community_guidelines.category_no_harmful_content": "Nessun contenuto nocivo",
    "community_guidelines.category_support_claims": "Sostienga le sue affermazioni",
    "community_guidelines.constructive_content_explanation": "**Commenti che potrebbero essere più costruttivi** possono ricevere suggerimenti su come essere più coerenti con le nostre norme comunitarie. Potrebbe avere la possibilità di rivedere il suo commento o procedere con la pubblicazione così com'è. I commenti pubblicati senza revisioni dopo aver ricevuto suggerimenti potrebbero essere classificati più in basso nel feed per dare priorità a contributi più costruttivi.",
    "community_guidelines.guidelines_intro": "Le linee guida della nostra comunità sono:",
    "community_guidelines.harmful_content_explanation": "**Contenuti dannosi** che violano le nostre linee guida della comunità saranno bloccati dalla pubblicazione. Se tale determinazione è stata fatta dall'IA, puo appellarsi a un moderatore umano per la revisione.\n\n**Commenti che potrebbero essere più costruttivi** possono ricevere suggerimenti su come essere più coerenti con le nostre norme della comunità. Può avere la possibilità di rivedere il suo commento o procedere con la pubblicazione come scritto. I commenti pubblicati senza revisioni dopo aver ricevuto suggerimenti possono essere classificati più in basso nel feed per dare priorità a contributi più costruttivi.",
    "community_guidelines.modal_heading": "Linee guida e norme della comunità",
    "community_guidelines.modal_intro": "Ci impegniamo a ispirare conversazioni reali, rispettose e aperte in questo spazio. Tutti sono invitati a condividere le proprie esperienze; scambiare e dibattere prospettive; e fare domande nello spirito di gentilezza, connessione e curiosità.",
    "community_guidelines.moderation_explanation": "Questo spazio è progettato per conversazioni più ponderate rispetto ai tipici commenti su internet. Il nostro processo di moderazione aiuta a mantenere tale standard rispettando la tua voce e prospettiva.",
    "community_guidelines.norms_intro": "Le nostre norme della comunità sono:",
    "community_guidelines.rule_avoid_derogatory_labels": "Evitare etichette denigratorie",
    "community_guidelines.rule_avoid_sarcasm": "Evitare sarcasmo e risposte sprezzanti",
    "community_guidelines.rule_explain_constructively": "Spiegare i disaccordi in modo costruttivo",
    "community_guidelines.rule_express_civility": "Esprimere le idee con civiltà",
    "community_guidelines.rule_focus_on_ideas": "Concentrarsi sulle idee, non sui giudizi personali",
    "community_guidelines.rule_no_illegal_content": "Nessun contenuto illegale",
    "community_guidelines.rule_no_offtopic": "Niente messaggi fuori tema",
    "community_guidelines.rule_no_spam": "Niente spam o promozione commerciale",
    "community_guidelines.rule_no_violent_content": "Nessun contenuto violento o incitamento al danno",
    "community_guidelines.rule_provide_sources": "Fornisci fonti per le affermazioni di fatto",
    "community_guidelines.rule_respect_privacy": "Rispetti la privacy degli altri, non condivida informazioni personali",
    "community_guidelines.title": "Linee guida della comunità",
    "community_guidelines.what_happens_heading": "Cosa succede quando il suo contributo viola le linee guida o le norme della comunità?",
    "context_entry_points.From": "Da",
    "context_entry_points.joined_from": "Unito da",
    "conversation_helper.analyze_conversation": "Analizzare la conversazione",
    "conversation_helper.checks_performed": "- **{count} controllo/i** effettuati",
    "conversation_helper.conversation_analysis": "Analisi della conversazione",
    "conversation_helper.conversation_stats": "Statistiche della conversazione",
    "conversation_helper.conversation_summary": "Riepilogo della conversazione",
    "conversation_helper.current_guidance": "Guida attuale",
    "conversation_helper.dashboard": "Pannello dell’assistente alla conversazione",
    "conversation_helper.disagree": "In disaccordo",
    "conversation_helper.explanation": "Spiegazione",
    "conversation_helper.generate_new_guidance": "Genera una nuova guida",
    "conversation_helper.generated_because": "Questo messaggio è stato generato perché...",
    "conversation_helper.guidance_messages_generated": "- **{count} messaggio/i guida generato/i",
    "conversation_helper.guidance_visible_to_everyone": "Questo messaggio guida è visibile a tutti.",
    "conversation_helper.hello_everyone": "Ciao a tutti!",
    "conversation_helper.help_history": "Cronologia dell’aiuto",
    "conversation_helper.helpful": "Utile",
    "conversation_helper.last_analysis_none": "- Ultima analisi della conversazione: **Nessuna**",
    "conversation_helper.last_analysis_time": "- Ultima analisi della conversazione: **{time}**",
    "conversation_helper.new_comments_since_analysis": "- **{count} nuovo/i commento/i** dall’ultima analisi",
    "conversation_helper.no_history": "Nessuna cronologia disponibile.",
    "conversation_helper.no_problems": "Nessun problema rilevato.",
    "conversation_helper.problems_detected": "Problemi rilevati!",
    "conversation_helper.related_space": "Discussione correlata",
    "conversation_helper.result": "Risultato: ",
    "conversation_helper.thank_you": "Grazie",
    "cta_button.loading": "Caricamento in corso",
    "dashboard.table.demo.pagination": "Spazi (Paginati)",
    "dashboard.table.demo.users": "Discussioni",
    "date.days_abbrev": "{days} giorni",
    "date.hours_abbrev": "{hours} ore",
    "date.minutes_abbrev": "{minutes} minuti",
    "date.months_abbrev": "{months} mesi",
    "date.now": "adesso",
    "date.years_abbrev": "{years} anni",
    "demo.comment": "commento",
    "demo.comments": "commenti",
    "demo.count_noun": "{count} {noun}",
    "demo.disagree": "In disaccordo",
    "demo.fwrd": "SUCCESSIVO",
    "demo.load_video_element": "Carica elemento video",
    "demo.new_to_me": "Nuovo per me",
    "demo.pause": "PAUSA",
    "demo.play": "RIPRODUCI",
    "demo.prev": "PRECEDENTE",
    "demo.respect": "Rispetto",
    "demo.thank_you": "Grazie",
    "demo.tile_admin_users_description": "Gestisci le autorizzazioni degli utenti amministratori.",
    "demo.tile_admin_users_label": "Utenti admin",
    "demo.tile_topics_label": "Argomenti",
    "developer_tools.email_testing": "Test email",
    "developer_tools.key": "Chiave",
    "developer_tools.send_test_email": "Invia email di prova",
    "developer_tools.sending": "Invio...",
    "developer_tools.title": "Strumenti per sviluppatori",
    "developer_tools.translation_queue": "Translation Queue",
    "developer_tools.translation_queue_description": "Process pending translation jobs for the current silo.",
    "developer_tools.translation_queue_done": "Elaborazione della coda di traduzione completata",
    "developer_tools.translation_queue_locked": "La coda è bloccata — un altro processo è già in esecuzione.",
    "developer_tools.translation_queue_process": "Process Queue",
    "developer_tools.translation_queue_processing": "Processing...",
    "developer_tools.translation_queue_result": "Elaborati: {processed}, Falliti: {failed}, Saltati: {skipped}",
    "developer_tools.translation_queue_stats": "Attività in coda: {total} ({pending} in attesa, {failed} fallite)",
    "developer_tools.unable_to_display": "Impossibile visualizzare le variabili d'ambiente.",
    "developer_tools.value": "Valore",
    "dialogue.recording_vote": "Registrazione del voto...",
    "dialogue.response_plural": "{count} risposte",
    "dialogue.response_singular": "{count} risposta",
    "dialogue.share_your_thoughts": "Condivida i suoi pensieri...",
    "dialogue.skip_submit_vote": "Saltare e inviare il voto",
    "dialogue.update_response": "Aggiornare la sua risposta",
    "dialogue_editable_labels.heading": "Personalizzare il dialogo",
    "dialogue_template.description": "Chiedere agli utenti di rispondere alla domanda con un semplice “sì” o “no”.",
    "dialogue_template.label": "Dialogo",
    "disagree": "In disaccordo",
    "editable_positions_widget.button_label": "Modificare le posizioni",
    "editable_positions_widget.label": "Posizione #{position}",
    "editorial_dash.title": "Pannello editoriale",
    "editorial_experts.with-experts": "Con esperti editoriali",
    "editorial_question.be_first": "Sia il primo a condividere i suoi pensieri",
    "editorial_question.count_noun": "{count} {noun}",
    "editorial_question.join_discussion": "Partecipare alla discussione",
    "editorial_question.lets_talk": "Parliamone...",
    "editorial_question.response_singular": "risposta",
    "editorial_question.responses_plural": "risposte",
    "editorial_question.share_thoughts": "Condivida i suoi pensieri",
    "error.api": "Qualcosa è andato storto",
    "error.network": "Errore di rete - Controllare la connessione a Internet e riprovare.",
    "features.srg_section": " SRG SSR",
    "filter_list_popover.trigger_more_filters": "Altri filtri",
    "footer.made_by": "Creato da ",
    "form.accordion.hide_details": "Nascondere dettagli",
    "form.accordion.show_details": "Mostrare dettagli",
    "form.add_button": "Aggiungere",
    "form.adding_button": "Aggiunta in corso...",
    "form.cancel_button": "Annullare",
    "form.create_space_button": "Creare uno spazio",
    "form.delete_button": "Elimina",
    "form.edit_button": "Modificare",
    "form.other": "Altro",
    "form.remove_button": "Rimuovere",
    "form.required_label": "{label} (obbligatorio)",
    "form.save_button": "Salvare",
    "form.uncheck_all": "Deselezionare tutto",
    "form.update_button": "Aggiornare",
    "format.count_noun": "{count} {noun}",
    "invite_user.button": "Invitare utente",
    "invite_user.error": "Impossibile invitare {email}. Per favore, riprovare.",
    "invite_user.modal.email_label": "Indirizzo email",
    "invite_user.modal.heading": "Invitare utente",
    "invite_user.modal.invite_button": "Invitare",
    "invite_user.success": "{email} è stato invitato.",
    "language.de-CH": "Tedesco (Svizzera)",
    "language.de-DE": "Tedesco",
    "language.en-US": "Inglese",
    "language.fr-BE": "Francese (Belgio)",
    "language.fr-CA": "Francese (Canada)",
    "language.fr-CH": "Francese (Svizzera)",
    "language.fr-FR": "Francese",
    "language.it-CH": "Italiano (Svizzera)",
    "language.it-IT": "Italiano",
    "language.nl-NL": "Olandese",
    "language.rm-CH": "Romancio",
    "legal.privacy_notice": "Informativa sulla privacy",
    "legal.terms_of_service": "Termini di servizio",
    "linked_partner_story.incomplete_list_banner": "Questo elenco di storie potrebbe essere incompleto.",
    "linked_partner_story.linked_articles_description": "Visualizzare le storie collegate a questa conversazione.",
    "linked_partner_story.linked_articles_heading": "Storie collegate",
    "linked_partner_story.no_articles_found": "Non ci sono ancora storie collegate a questo spazio.",
    "linked_partner_story.read_article_link": "Leggere l'articolo",
    "linked_partner_story.view_video_link": "Guardare il video",
    "loading": "Caricamento...",
    "login.account_blocked_explanation": "Nessuna azione necessaria per la beta. Solo un moderatore può ripristinare l'accesso alla discussione.",
    "login.account_blocked_heading": "Non puoi accedere perché il tuo account è bloccato",
    "login.account_not_impacted": "Il tuo account {siloName} non è interessato ed è ancora accessibile.",
    "login.continue_with": "Continuare con {providerName}",
    "login.continue_with_google": "Continuare con Google",
    "login.default_admin_login_heading_label": "Benvenuto in {psiBrandName}",
    "login.default_admin_login_subheading_label": "Accedere con l'account Admin per iniziare",
    "login.default_login_heading_label": "Uno spazio per discussioni sane e prospettive varie",
    "login.dev_login": "Login Sviluppatore",
    "login.logging_in": "Accesso in corso...",
    "login.okay_button": "Va bene",
    "login.select_dev_persona": "Seleziona una persona sviluppatore",
    "login.sso_error": "Qualcosa è andato storto durante l'accesso. Chiudere questa finestra e riprovare.",
    "main.checkbox.label": "Nuovi contributi in fase di revisione",
    "modal.cancel_button": "Annullare",
    "modal.close_button": "Chiudi",
    "modal.confirm_leave_button": "Uscire",
    "moderation.admin_bypass_ai_and_manual_moderation": "Questo spazio ha la moderazione AI e umana abilitata, ma come utente Admin bypasserai automaticamente entrambe.",
    "moderation.admin_bypass_ai_moderation": "Questo spazio ha la moderazione AI abilitata, ma come utente Admin la bypasserai automaticamente.",
    "moderation.admin_bypass_manual_moderation": "Questo spazio ha la moderazione umana abilitata, ma come utente Admin la bypasserai automaticamente.",
    "moderation.admin_filter_notice": "Per contribuire a migliorare la moderazione dell'IA, invii uno screenshot del suo post e questo messaggio al suo team.",
    "moderation.ai_and_manual_label": "Moderato da AI e manualmente",
    "moderation.ai_flagged_thing": "L'IA ha segnalato {moderatedThing}",
    "moderation.ai_mistake_explanation": "L’IA ci aiuta a moderare i commenti, ma a volte può sbagliare. Se l’IA ti impedisce di condividere un’opinione rispettosa, invia il tuo commento a un moderatore per una revisione.",
    "moderation.ai_wrong_question": "L’IA ha sbagliato?",
    "moderation.approved_tag": "Approvato",
    "moderation.automaticallyApproved": "Approvato automaticamente",
    "moderation.awaitingDecision": "In attesa di decisione",
    "moderation.blocked": "Bloccato",
    "moderation.bypassedPremoderation": "Premoderazione bypassata",
    "moderation.dash.approve": "Approvare",
    "moderation.dash.base_filter._rejected": "Rifiutato manualmente",
    "moderation.dash.base_filter.approved": "Approvato",
    "moderation.dash.base_filter.auto_approved": "Approvato automaticamente",
    "moderation.dash.base_filter.awaiting_decision": "In attesa di decisione",
    "moderation.dash.block_user": "Bloccare l’utente",
    "moderation.dash.operation_error": "Operazione non riuscita, per favore riprovare",
    "moderation.dash.reject": "Rifiutare",
    "moderation.dash.time": "volta",
    "moderation.dash.times": "volte",
    "moderation.dash.user_must_be_warned_2_times": "Un utente deve essere avvertito 2 volte prima di poter essere bloccato.",
    "moderation.dash.user_successfully_unblocked": "{user} è stato sbloccato con successo",
    "moderation.deletedByUser": "Eliminato dall'utente",
    "moderation.deletedUser": "Utente eliminato",
    "moderation.email_notification": "Riceverai una notifica via e-mail quando il tuo post sarà approvato o rifiutato dai moderatori.",
    "moderation.email_notification_notice": "Riceverai una notifica via e-mail quando il tuo post sarà approvato o rifiutato dai moderatori.",
    "moderation.heated": "Acceso",
    "moderation.infoBannerLoader.label": "Revisione della sua risposta...",
    "moderation.info_ai_and_manual_moderation_banner_text": "Per mantenere un ambiente accogliente e rispettoso, tutti i post in questo spazio sono moderati sia da AI che manualmente prima della pubblicazione per garantire che seguano le [Linee guida della comunità]($onPress)",
    "moderation.info_manual_moderation_banner_text": "Per mantenere un ambiente accogliente e rispettoso, tutti i post in questo spazio sono moderati manualmente prima della pubblicazione per rispettare le [Linee guida della comunità]($onPress)",
    "moderation.liveThread": "Discussione in diretta",
    "moderation.manuallyApproved": "Approvato manualmente",
    "moderation.manuallyRejected": "Rifiutato manualmente",
    "moderation.message_to_moderator_placeholder": "Messaggio al moderatore...",
    "moderation.mode_manual": "Moderazione manuale",
    "moderation.new": "Nuovo",
    "moderation.popular": "Popolare",
    "moderation.postedAnyway": "Pubblicato comunque",
    "moderation.provide_details_help": "Fornisci eventuali dettagli per aiutarci a determinare se il tuo post rispetta le nostre linee guida.",
    "moderation.rejected_by_moderator": "Rifiutato dal moderatore",
    "moderation.select_all_that_apply": "Selezioni tutte quelle che si applicano.",
    "moderation.send_for_review_button": "Inviare a un moderatore per la revisione",
    "moderation.send_to_moderator_button": "Inviare al moderatore",
    "moderation.send_to_moderator_title": "Inviare al moderatore",
    "moderation.sending": "Invio in corso...",
    "moderation.sent_for_review_message": "La sua risposta è stata inviata al moderatore per la revisione.",
    "moderation.sent_to_moderator": "La sua risposta è stata inviata al moderatore per la revisione.",
    "moderation.sent_to_moderator_time": "Inviato al moderatore: {time}",
    "moderation.share_details": "Condividere i dettagli",
    "moderation.singularTerm": "Termine singolare",
    "moderation.system_unavailable_message": "Il nostro sistema di moderazione AI temporaneamente non è disponibile. Può comunque inviare il suo post a un moderatore umano per la revisione.",
    "moderation.system_unavailable_title": "⚠️ Sistema di moderazione temporaneamente non disponibile",
    "moderation.thank_you": "Grazie!",
    "moderation.under_review": "In revisione",
    "moderation.use_ai_title": "✨ Usiamo l'IA per la moderazione",
    "moderation.warned": "Avvisato",
    "moderation.what_guideline_violate": "Quali linee guida vengono violate da questo commento?",
    "moderation.what_happens_next": "📫 Cosa succede ora",
    "moderation.zdfComment": "Commento ZDF",
    "moderation_card.language_tag": "{locale} | Tradotto",
    "most_popular.most_popular_label": "Più popolari",
    "most_popular.most_recent_label": "Più recenti",
    "most_popular.show_more_button": "Mostrare più risposte",
    "navigation_header.back_button": "Indietro",
    "notification.dismiss_button": "Ignorare",
    "onboarding.dismiss_button": "Ignorare",
    "pagination_row.previous_page": "Pagina precedente",
    "pagination_row.showing": "Visualizzazione {start}-{end} di {total}",
    "perspectives.add_new_perspective": "Aggiungere una nuova prospettiva",
    "perspectives.add_your_own": "Aggiunga la sua",
    "perspectives.add_your_perspective": "Aggiunga la sua prospettiva",
    "perspectives.havent_heard_yet": "Non abbiamo ancora sentito queste prospettive",
    "perspectives.how_relate_question": "Qual è il suo rapporto con questa questione?",
    "perspectives.poll_title": "Contributi finora",
    "perspectives.share_thoughts_button": "Condivida i suoi pensieri",
    "perspectives.title": "Prospettive",
    "pin_comment.feature_label": "Mettere in evidenza",
    "pin_comment.featured_label": "In evidenza",
    "pin_to_feed.move_down": "Spostare giù",
    "pin_to_feed.move_up": "Spostare su",
    "pin_to_feed.pin_label": "Fissare",
    "pin_to_feed.pinned_label": "Fissato",
    "poll.change_vote_button": "Modifica la mia risposta",
    "poll.result_vote": "{tLabel}: {percent}%",
    "poll.result_your_vote": "{tLabel} (tuo voto): {percent}%",
    "poll.submit_vote_button": "Invia il mio voto",
    "poll.write_in_topic": "Scrivi un argomento...",
    "poll_question.add_option_button": "Aggiungere opzione",
    "poll_question.options_label": "Opzioni del sondaggio",
    "poll_question.question_label": "Domanda del sondaggio",
    "popup.close_button": "Chiudere finestra",
    "popup_tip.more_information": "Maggiori informazioni",
    "post.post_anyway_button": "Pubblicare comunque",
    "post.posting_anyway": "Pubblicazione comunque...",
    "post.submit": "Inviare",
    "post.submitting": "Invio in corso...",
    "post.update": "Aggiornare",
    "post.update_anyway_button": "Aggiornare comunque",
    "post.updating": "Aggiornamento in corso...",
    "post.updating_anyway": "Aggiornamento comunque...",
    "profile.add_custom_name": "Aggiungi un nome personalizzato",
    "profile.custom_photo_label": "Foto profilo personalizzata",
    "profile.edit.custom-title": "Aggiungere un titolo personalizzato",
    "profile.edit.custom_title": "Aggiungere un titolo personalizzato",
    "profile.edit.heading": "Modificare",
    "profile.edit.name": "Nome profilo",
    "profile.edit.name_override": "Nome",
    "profile.edit.name_override.placeholder": "Aggiungere nome alternativo...",
    "profile.edit.override_name_title": "Sostituire nome del profilo",
    "profile.edit.override_photo_title": "Sostituire foto del profilo",
    "profile.edit.photo": "Foto profilo",
    "profile.edit.photo_override": "URL foto",
    "profile.edit.photo_override.placeholder": "Aggiungere l'URL alternativo...",
    "profile.edit.title": "Titolo",
    "profile.edit_module_button": "Modificare {tLabel}",
    "profile.error_name_empty": "I nomi personalizzati non possono essere vuoti.",
    "profile.error_name_invalid": "I nomi personalizzati possono contenere solo lettere minuscole e numeri.",
    "profile.error_name_looks_real": "I nomi personalizzati non devono sembrare nomi reali.",
    "profile.error_name_taken": "Questo nome personalizzato è già in uso.",
    "profile.error_name_violates": "Questo nome personalizzato non è conforme alle nostre linee guida della comunità.",
    "profile.finish_button": "Fine",
    "profile.go_to.edit": "Modificare sostituzioni",
    "profile.is_titled_writer": "È un autore titolato",
    "profile.loading": "Caricamento del profilo...",
    "profile.module_name": "nome",
    "profile.module_photo_and_name": "foto e nome",
    "profile.name_label": "Nome del profilo",
    "profile.no_user_error": "Utente inesistente",
    "profile.photo_label": "La sua foto del profilo",
    "profile.photo_url_aria": "URL della foto",
    "profile.photo_url_placeholder": "URL della foto",
    "profile.please_wait": "Attendere...",
    "profile.public_overriden": "Le sue informazioni sono state modificate da un amministratore",
    "profile.setup_title": "Impostare il profilo",
    "profile.title_heading": "Titolo",
    "profile.title_placeholder": "Inserire un titolo",
    "profile.username_placeholder": "utente123",
    "profile_answers.admins_can_view": "Gli amministratori e i moderatori possono sempre vedere la tua cronologia.",
    "profile_answers.discussion_history": "Cronologia delle discussioni",
    "profile_answers.edit_visibility": "Modificare visibilità",
    "profile_answers.history_private": "La cronologia di questo utente è privata.",
    "profile_answers.rejected": "Il commento è stato respinto da un moderatore",
    "profile_answers.under_review": "Il commento è in revisione",
    "profile_answers.visible_to_everyone": "Visibile a tutti",
    "profile_menu.dialog_label": "Menu del profilo",
    "profile_menu.menu_label": "Account",
    "question.actions.close_button": "Chiudi",
    "question.actions.close_confirm_button": "Chiudi",
    "question.actions.close_modal_description": "Quando una sezione viene chiusa, diventa di sola lettura. La maggior parte delle azioni viene disabilitata e gli utenti non possono più pubblicare commenti, rispondere o reagire. Gli utenti possono comunque segnalare i commenti. È possibile riaprire la conversazione in qualsiasi momento.",
    "question.actions.close_modal_heading": "Chiudere questo spazio?",
    "question.actions.copy_button": "Copiare",
    "question.actions.edit_button": "Modificare",
    "question.actions.link_copied_toast": "Link copiato negli appunti!",
    "question.actions.linked_stories_button": "Storie collegate",
    "question.actions.preview_button": "Anteprima",
    "question.actions.reopen_button": "Riaprire",
    "question.actions.reopen_confirm_button": "Riaprire",
    "question.actions.reopen_modal_heading": "Riaprire questo spazio?",
    "question.actions.tooltip": "Più opzioni",
    "question.add_content_label": "Agiunscha cuntegn",
    "question.add_spaces_label": "Agiunscha spazis",
    "question.all_responses_tab": "Tutti i commenti",
    "question.conversation_format": "Formato della conversazione",
    "question.conversation_type_section": "Tipo di conversazione",
    "question.count_noun_format": "{count} {noun}",
    "question.error_empty_prompt": "Il prompt non può essere vuoto.",
    "question.error_prompt_too_long": "Il prompt deve contenere meno di {num} caratteri.",
    "question.general_section": "Generale",
    "question.input_placeholder": "Condividi i tuoi pensieri...",
    "question.moderation_label": "Moderazione",
    "question.no_comments_message": "Sia il primo a condividere i suoi pensieri",
    "question.no_comments_title": "Inizi la conversazione",
    "question.no_teaser_error": "Nessun teaser definito",
    "question.not_exist": "Questa domanda non esiste",
    "question.prosocial_ranking_section": "Classifica prosociale",
    "question.public_response_subtitle": "Risposta pubblica",
    "question.reaction_list_tooltip": "Vedere le reazioni",
    "question.reaction_plural": "reazioni",
    "question.reaction_singular": "reazione",
    "question.reply_placeholder": "Rispondere a {authorName}...",
    "question.reply_plural": "risposte",
    "question.reply_singular": "risposta",
    "question.upvote_plural": "voti positivi",
    "question.upvote_singular": "voto positivo",
    "question.your_response_title": "La tua risposta:",
    "rating.its_complicated": "È complicato",
    "rating.no_with_reservations": "Piuttosto no",
    "rating.strongly_no": "Decisamente no",
    "rating.strongly_yes": "Decisamente sì",
    "rating.yes_with_reservations": "Piuttosto sì",
    "reaction_types.appreciation_plural": "apprezzamenti",
    "reaction_types.appreciation_singular": "apprezzamento",
    "reaction_types.constructive": "Costruttivo",
    "reaction_types.controversial": "Controverso",
    "reaction_types.count_noun": "{count} {noun}",
    "reaction_types.default_set": "Set predefinito",
    "reaction_types.empathetic": "Empatico",
    "reaction_types.enjoyable": "Piacevole",
    "reaction_types.fun_space": "Spazio divertente",
    "reaction_types.funny": "Divertente",
    "reaction_types.helpful": "Utile",
    "reaction_types.insightful": "Perspicace",
    "reaction_types.interesting": "Interessante",
    "reaction_types.nuanced": "Sfumato",
    "reaction_types.personal_space": "Spazio personale",
    "reaction_types.playful": "Giocoso",
    "reaction_types.relatable": "Mi ci ritrovo",
    "reaction_types.serious_space": "Spazio serio",
    "reaction_types.surprising": "Sorprendente",
    "reaction_types.why_appreciate": "Perché apprezzi questo post?",
    "related_content.article_option": "Articolo",
    "related_content.audio_option": "Audio",
    "related_content.learn_more": "Scoprire di più su questo argomento",
    "related_content.show_more_button": "Mostra di più",
    "related_content.url_placeholder": "https://www.esempio.com",
    "related_content.video_option": "Video",
    "related_conversations.add_spaces_button": "Aggiungere spazi",
    "related_conversations.next_button": "Successivo",
    "related_conversations.no_spaces_found": "Nessuno spazio trovato",
    "related_conversations.participant_count": "{count} {noun}",
    "related_conversations.participant_plural": "partecipanti",
    "related_conversations.participant_singular": "partecipante",
    "related_conversations.previous_button": "Precedente",
    "related_conversations.title": "Conversazioni correlate",
    "representing_perspectives_template.description_1": "Scegli **3-5 prospettive specifiche** da cui vuoi sentire (es. «🏖️ Pensionato», «📦 Nuovo residente», «🍼 Genitore che lavora», ecc.)",
    "representing_perspectives_template.description_2": "Evita prospettive basate sulla demografia (es. «urbano», «basso reddito», «donna», ecc.) che potrebbero portare a stereotipi",
    "representing_perspectives_template.description_3": "Evita di attribuire convinzioni alle prospettive (es. «persona con un atteggiamento conservatore», o «sostenitori» e «oppositori»)",
    "representing_perspectives_template.description_4": "Scegli un'emoji per ogni prospettiva",
    "representing_perspectives_template.form_field_label": "Prospettive",
    "representing_perspectives_template.helper_label": "Definisci le tue prospettive",
    "roles.moderator": "Moderatore",
    "roles.owner": "Proprietario",
    "satisfaction_survey_popover.question": "Quanto sei soddisfatto di questa piattaforma di discussione?",
    "satisfaction_survey_popover.satisfied_label": "Molto soddisfatto",
    "satisfaction_survey_popover.unsatisfied_label": "Molto insoddisfatto",
    "saving": "Salvataggio in corso...",
    "search.placeholder": "Cerca...",
    "settings.comment_slider_label": "Cursore commento",
    "settings.video_voting_label": "Votazione video",
    "simple_ranking.most_reactions": "Più reazioni",
    "simple_ranking.newest": "Più recenti",
    "single_response_help.same_question_title": "Stessa domanda, nuovo articolo?",
    "single_response_help.update_response_label": "Aggiorna la tua risposta precedente con nuove prospettive",
    "slider_with_stop_points.aria_label": "Usa le frecce sinistra e destra oppure su e giù per regolare il cursore",
    "sort.all": "Tutti",
    "sort.ascending": "A-Z",
    "sort.most_recent": "Più recenti",
    "sort.top": "Top",
    "sort_button.aria_label": "Ordina per {text}",
    "sort_menu.sort_by_header": "Ordina per",
    "sorting.oldest": "Più vecchio",
    "space.table.demo.responses": "risposte",
    "space.table.search": "Cerca...",
    "spaces.column_comments": "Commenti",
    "spaces.column_creationDate": "Creato",
    "spaces.column_responses": "risposte",
    "spaces.column_status": "Stato",
    "spaces.filter_active": "Attivo",
    "spaces.filter_closed": "Chiuso",
    "spaces.status_active": "Attivo",
    "spaces.status_closed": "Chiuso",
    "spaces.still_need_help": "Ancora bisogno di aiuto?",
    "spaces.tab_label": "Discussioni",
    "spaces.title": "Discussioni",
    "spaces.visit_playbook": "Visita il PSI Playbook",
    "srg.profile.error_name_invalid": "I nomi personalizzati possono contenere solo lettere, numeri, spazi e trattini.",
    "standalone_question.participant": "partecipante",
    "standalone_question.participants": "partecipanti",
    "status.reported": "Segnalato",
    "story_dash.date_column": "Pubblicato",
    "story_dash.remove_modal_description": "Questa azione non può essere annullata. Qualsiasi spazio collegato verrà scollegato.",
    "story_dash.remove_modal_description_2": "Puoi aggiungere nuovamente la storia in qualsiasi momento e collegarla a uno spazio.",
    "story_dash.remove_modal_heading": "Rimuovere questa storia?",
    "strongly_agree": "Totalmente d’accordo",
    "strongly_disagree": "Totalmente in disaccordo",
    "survey.feedback_help": "Il tuo feedback ci aiuterà a migliorare la tua esperienza.",
    "survey.strongly_agree": "Totalmente d’accordo",
    "survey.strongly_disagree": "Totalmente in disaccordo",
    "survey.tell_us_experience": "Raccontaci la tua esperienza",
    "survey.thank_you": "Grazie per aver condiviso la tua esperienza con noi!",
    "tag.beta": "Beta",
    "template.perspectives_label": "Prospettive",
    "text.character_count": "{count}/{max} caratteri",
    "text.character_count_max": "{count}/{max} caratteri massimo",
    "text.character_count_min": "minimo {min} caratteri",
    "text.character_count_over_max": "{count}/{max} caratteri massimo",
    "text.character_count_progress_min": "{count}/{min} caratteri minimo",
    "tile.experimental_label": "Beta",
    "tile.outdated_label": "Obsoleto",
    "time.format": "{time}",
    "upvote.aria_label": "Voto positivo",
    "usability_survey.easy_to_use_question": "Questa piattaforma di discussione è facile da usare",
    "usability_survey.meets_needs_question": "Questa piattaforma soddisfa le mie esigenze",
    "user.member": "Membro",
    "user_info.account_button": "Account",
    "user_info.admin": "Amministratore",
    "user_info.developer_features": "Funzionalità per sviluppatori",
    "user_info.faqs": "FAQ",
    "user_info.log_in_button": "Accedi",
    "user_info.log_out_button": "Uscire",
    "user_info.profile_button": "Profilo",
    "user_info.profile_menu_aria_label": "Menu del profilo per {name}",
    "video_link.go_to_video": "Vai al video",
    "video_voting.continue_button": "Continua",
    "video_voting.create_new_voting": "Crea un nuovo voto",
    "video_voting.deactivate_all": " puoi disattivare questa funzione per tutti i video.",
    "video_voting.enable_all_videos": "Attiva il voto per tutti i video",
    "video_voting.enable_voting": "Abilita il voto",
    "video_voting.intro_text": "Questo video contiene domande del pubblico a cui puoi partecipare. Puoi votare in modo anonimo, saltare singole domande o disattivare questa funzione. Nelle ",
    "video_voting.join_discussion": "Unisciti alla discussione",
    "video_voting.manage_voting_admin": "Gestisci i voti (Admin)",
    "video_voting.no_data_available": "Nessun dato di voto disponibile",
    "video_voting.not_logged_in_text": "Devi effettuare il login per usare questa funzione.\nIl video verrà riprodotto normalmente e non vedrai le votazioni.\n**Clicca qui per accedere**.",
    "video_voting.select_voting_for_article": "Seleziona un voto per questo articolo",
    "video_voting.settings": "preferenze",
    "video_voting.start_video": "Avvia il video",
    "video_voting.time": "Tempo:",
    "video_voting.title": "Votazione video",
    "video_voting.vote_anonymously": "Vota in modo anonimo",
    "video_voting.votings_tab": "Voti",
    "video_voting.you": "Tu",
    "videovoting.select_chapter": "Selezionare un capitolo",
    "videovoting.select_existing_voting": "Selezionare un voto video esistente",
    "videovoting.select_question": "Selezionare una domanda",
    "visibility.only_visible_to_admins": "Visibile solo agli Admin",
    "vote.delete_button": "Eliminare",
    "vote.delete_modal_heading": "È sicuro di voler eliminare il tuo voto?",
    "vote.delete_modal_warning": "Questa azione non può essere annullata.",
    "voting.no": "No",
    "voting.yes": "Sì",
    "zdf_admin.votings": "Voti",
    "{count} {noun}": "{count} {noun}"
}
